import React, { useEffect, useState } from "react";
import MyUser from "@/components/business/User";
import Notice from "@/components/business/Notice";
import { useNavigate } from "react-router-dom";
import User from "@/stores/userStore";
import { observer } from "mobx-react";
import { Popover } from "@arco-design/web-react";
import dayjs from "dayjs";
import { getUserPermissions } from "@/components/business/RolePermission";
import { aidConfig } from "@/platformConfig";
import "./index.less";

const Header: React.FC = () => {
  const navigate = useNavigate();

  const [overHeight, setOverHeight] = useState<boolean>(false);
  useEffect(() => {
    const image = new Image();
    image.src = aidConfig.loginIcon;
    image.onload = function () {
      setOverHeight(image.height >= image.width);
    };
  }, []);
  return (
    <div className="header_root">
      <div
        className="logo-box"
        onClick={() => {
          navigate("/account-management");
        }}
      >
        <div style={{ width: User.logoWidth, textAlign: "center" }}>
          <img
            src={aidConfig.logo}
            style={{ marginTop: 2, width: overHeight ? "auto" : "90%", height: overHeight ? "60px" : "auto" }}
          />
        </div>
      </div>
      {getUserPermissions("6") && (
        <div className="head-user-money">
          <div className="user-money-item">
            <div className="item-label">云币:</div>
            <div className="item-value">{User.userInfo.balance ? User.userInfo.balance / 100 : "-"}</div>
          </div>
          <Popover
            content={User.userInfo.banlance?.map((v, i) => (
              <div key={i} style={{ padding: 10 }}>
                <p>
                  活动币: {v.balance ? v.balance / 100 : 0},{" "}
                  {v.expired_at ? dayjs.unix(v.expired_at).format("YYYY-MM-DD HH:mm:ss") : "-"}
                  到期
                </p>
              </div>
            ))}
          >
            <div className="user-money-item">
              <div className="item-label">活动币:</div>
              <div className="item-value">
                {User.userInfo.banlance?.length
                  ? User.userInfo.banlance.reduce((pre, cur) => {
                      if (cur.expired_at < new Date().getTime() / 1000) {
                        return pre;
                      }
                      return pre + (cur.balance ? cur.balance / 100 : 0);
                    }, 0)
                  : "-"}
              </div>
            </div>
          </Popover>
          <div className="user-money-item">
            <div className="item-label">数字人时长:</div>
            <div className="item-value">{User.userInfo.digital_time ? `${User.userInfo.digital_time}s` : "-"}</div>
          </div>
        </div>
      )}
      <div className="tool-box">
        <Notice />
        <div>
          <MyUser />
        </div>
      </div>
    </div>
  );
};

export default observer(Header);
